import I18n from 'I18n';
import ActionButtonComponent from '../ActionButtonComponent';
import { getUsageTrackingChannel } from '../../usage-tracker/trackerChannelIdMapping';
import { usageTracker } from '../../usage-tracker/usageTracker';
import { ViewIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const UnhideButton = ({
  collapsed,
  unhideEnabled,
  genericChannelId,
  onClick
}) => {
  const onButtonClick = e => {
    onClick(e);
    usageTracker.track('message-unhide', {
      action: 'message unhide',
      channel: genericChannelId ? getUsageTrackingChannel(genericChannelId) : undefined
    });
  };
  if (unhideEnabled) {
    return /*#__PURE__*/_jsx(ActionButtonComponent, {
      onClick: onButtonClick,
      collapsed: collapsed,
      buttonIcon: ViewIcon,
      "data-test-id": 'unhide-button',
      i18nButtonText: I18n.text('conversations-inbox-message-history.common-message.unhideMessage'),
      tooltipProps: {
        title: I18n.text('conversations-inbox-message-history.common-message.unhideMessageDetail'),
        placement: 'right'
      }
    });
  }
  return /*#__PURE__*/_jsx(ActionButtonComponent, {
    collapsed: collapsed,
    buttonIcon: ViewIcon,
    "data-test-id": 'unhide-button-disabled',
    i18nButtonText: I18n.text('conversations-inbox-message-history.common-message.unhideMessage'),
    tooltipProps: {
      title: I18n.text('conversations-inbox-message-history.common-message.unhideMessageDetailDisabled'),
      placement: 'right'
    },
    disabled: true
  });
};
UnhideButton.displayName = 'UnhideButton';
export default UnhideButton;